import { Component } from 'react'
import { listSavedJobs } from '../../../../../../insfrastructure/services/saved-jobs';
import { StaticValues } from '../../../../../../insfrastructure/services/static_values';
import './styles.sass'
import { Link } from 'react-router-dom';
import { generateKey } from '../../../../../../insfrastructure/utils/array-key';

export default class SavedJobs extends Component {
  state: any = {
    saved_jobs: null,
    job_types: {},
  }

  BRLReal = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })

  async componentDidMount() {
    this.getStaticValues();
    this.getSavedJobs();
  }

  getSavedJobs = async () => {
    try {
      const response = await listSavedJobs(localStorage.getItem('candidate_id'));

      this.setState({ saved_jobs: response });
    } catch (error) {}
  }

  getStaticValues = async () => {
    try {  
      const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;          
      const job_types = staticValues.job_type;
  
      this.setState({ job_types });
    } catch (error) {}
  }

  render() {
    return (
      <div className='saved-offers'>
        <h1>Vagas Salvas</h1>
        <div className='saved-offers-list'>
          { this.state.saved_jobs && this.state.saved_jobs.length === 0 && <p>Nenhuma vaga salva</p> }
          {
            this.state.saved_jobs && this.state.saved_jobs.length > 0 && this.state.saved_jobs.map((x: any, i: number) => 
            <Link 
              key={generateKey('saved_offer_'+i)}
              to={`/offers/${x.job_post}/details`}>
              <div className='saved-offer'>
                <h4>{x.job_title}</h4>
                <div>
                  {/* <p>Tipo de Vaga: <b>{this.state.job_types[x.job_type.toLowerCase()]}</b></p> */}
                  <p>Tipo de Vaga: <b>{x.job_type}</b></p>
                  <p>Local: <b>{x.city}, {x.state}</b></p>
                  <p>Data: <b>{x.start_date}</b></p>
                  {/* <p>Salário: <b>{this.BRLReal.format(x.salary)}</b></p> */}
                  <p>Salário: <b>{x.salary}</b></p>
                  <p>Empresa: <b>{x.company}</b></p>
                </div>
              </div>
            </Link>)
          }
        </div>
      </div>
    )
  }
}
